import { toast } from "react-toastify";
import {auctionAddresss, eggAssetTokenId, exchangeToeknAddress, nodeUrl} from './Constants';
const wavesTransaction = require('@waves/waves-transactions')

export async function exchangeToken(amount, bidderSeed) {
    const initAuctionTx = wavesTransaction.invokeScript({
        dApp: exchangeToeknAddress,
        fee: 900000,
        call: {
            function: "exchangeToken",
            args: [{ "type": "integer", "value": amount }] //amount
        },
        payment: [{
            assetId: null, // egg asset toekn id
            amount: amount
        }],
        chainId: 84
    }, bidderSeed);

    let result = false;
    try {
        let tx = await wavesTransaction.broadcast(initAuctionTx, nodeUrl);
        console.log('Token exchanged successfully: ' + tx.id);
        result = true;
    } catch (e) {
        toast.error(e.message);
    }
    return result;
}
